var _rect, _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 27,
    viewBox: "0 0 45 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.148,
    width: 45,
    height: 21.927,
    rx: 10.964,
    fill: "#41732A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_760_84341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.954 1.721c0-.95.73-1.721 1.63-1.721h15.178c.9 0 1.63.77 1.63 1.721V25.28c0 .95-.73 1.721-1.63 1.721H4.584c-.9 0-1.63-.77-1.63-1.721V1.72z",
    fill: "#D0392B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.762.86H4.584c-.45 0-.815.386-.815.861V25.28c0 .475.365.86.815.86h15.178c.45 0 .815-.385.815-.86V1.72c0-.475-.365-.86-.815-.86zM4.584 0c-.9 0-1.63.77-1.63 1.721V25.28c0 .95.73 1.721 1.63 1.721h15.178c.9 0 1.63-.77 1.63-1.721V1.72c0-.95-.73-1.721-1.63-1.721H4.584z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.605 1.721c0-.95.701-1.721 1.565-1.721h14.571c.864 0 1.565.77 1.565 1.721v23.558c0 .95-.7 1.72-1.565 1.72h-14.57c-.865 0-1.566-.77-1.566-1.72V1.72z",
    fill: "#D0392B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.721 12.513l.832 2.264-2.048-1.387-1.971 1.42.704-2.277-2.05-1.386 2.487-.02.703-2.278.83 2.263 2.484-.02-1.97 1.421zm1.61-3.694c-1.853-1.716-3.032-2.78-3.032-2.78s-1.12 1.084-2.873 2.83c-.926.922-3.002 3.206-2.94 5.46.043 1.504 1.344 2.712 2.908 2.698 1.026-.009 1.598-.306 2.381-1.332 0 0 .128-.107.22-.108.146-.001.281.097.27.22-.087.81-.506 2.812-2.358 3.502l5.524-.047c-1.89-.657-2.42-2.652-2.55-3.461-.021-.122.11-.222.255-.223.09-.001.227.104.227.104.82.812 1.427 1.3 2.453 1.29 1.563-.012 2.797-1.242 2.754-2.744-.062-2.255-2.264-4.504-3.24-5.409z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.741.86h-14.57c-.433 0-.783.386-.783.861v23.558c0 .475.35.86.782.86h14.571c.432 0 .782-.385.782-.86V1.72c0-.475-.35-.86-.782-.86zM25.171 0c-.865 0-1.566.77-1.566 1.721v23.558c0 .95.701 1.72 1.565 1.72h14.571c.864 0 1.565-.77 1.565-1.72V1.72c0-.95-.7-1.721-1.565-1.721h-14.57z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.633 12.513l.832 2.264-2.048-1.387-1.971 1.42.704-2.277-2.05-1.387 2.487-.02.703-2.277.83 2.263 2.484-.021-1.97 1.422zm1.61-3.694a359.556 359.556 0 00-3.032-2.78s-1.12 1.083-2.873 2.83c-.926.921-3.002 3.206-2.94 5.46.043 1.503 1.344 2.712 2.908 2.697 1.026-.008 1.599-.305 2.381-1.331 0 0 .129-.107.22-.108.146-.002.281.096.27.22-.087.81-.506 2.812-2.358 3.502l5.524-.047c-1.89-.657-2.42-2.652-2.55-3.461-.02-.122.11-.222.255-.223.09-.001.227.104.227.104.82.812 1.427 1.3 2.453 1.29 1.563-.012 2.798-1.242 2.754-2.744-.062-2.255-2.264-4.504-3.24-5.409z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_760_84341"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.954)",
    d: "M0 0h18.438v27H0z"
  })))));
}
SvgActiveTable.displayName = 'ActiveTable';
export default SvgActiveTable;